<template>
    <div>
        <div class="lesson-content-frame" :class="{'container is-max-widescreen': enrollment.course.content_framed}">

            <lesson-header :component="component" :enrollment="enrollment" :outline="outline"/>


            <render-component :component="component" :data="enrollment.data" @saveData="saveData"/>

<!--            <json-viewer :value="outline"/>-->

        </div>

        <div class="content-controls">
            <div class="columns">
                <div class="column is-8">
                    <div v-if="quizGraded">
                        <div class="is-size-6 ml-1">
                            You got <strong>{{quizResults.correct}}</strong> of <strong>{{quizResults.questions}}</strong> questions correct for a score of <strong>{{Math.ceil(quizResults.score * 100)}}%</strong>.

                            <div v-if="outline.quiz_min_score && Math.ceil(quizResults.score * 100) < outline.quiz_min_score">
                                You must achieve a score of <strong>{{outline.quiz_min_score}}</strong>% to continue.  Please retry the assessment.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column has-text-right">
                    <div v-if="quizGraded">
                        <div v-if="outline.quiz_min_score && Math.ceil(quizResults.score * 100) < outline.quiz_min_score">
                            <b-button type="is-white" outlined @click="retryQuiz()" class="ml-5">Retry Assessment<i class="fas fa-undo ml-3"></i></b-button>
                        </div>
                        <div v-else>
                            <b-button type="is-white" outlined v-if="outline.prevOutlineId" @click="$emit('goto', outline.prevOutlineId)"><i class="fas fa-arrow-left mr-3"></i>Previous</b-button>
                            <b-button type="is-white" outlined class="ml-5" v-if="outline.completed_at && outline.nextOutlineId" @click="$emit('goto', outline.nextOutlineId)">Next<span v-if="outline.counts.ofSection === outline.counts.totalSection"> Section</span><i class="fas fa-arrow-right ml-3"></i></b-button>
                            <b-button type="is-white" outlined @click="$emit('complete')" class="ml-5" v-if="!outline.completed_at">Complete<span v-if="outline.counts.ofSection === outline.counts.totalSection"> Section</span><i class="fas fa-check ml-3"></i></b-button>
                        </div>
                    </div>
                    <div v-else>
                        <b-button type="is-white" outlined @click="gradeQuiz()" class="ml-5">Grade Assessment<i class="fas fa-list-check ml-3"></i></b-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from "moment";
    import LessonHeader from "./LessonHeader";
    import RenderBlocks from "./RenderBlocks";
    import RenderComponent from "../RenderComponent";

    export default {
        components: {RenderComponent, RenderBlocks, LessonHeader},
        props: ['enrollment', 'component', 'outline', 'time'],
        data: function() {
            return {
                quizGraded: false,
            };
        },
        computed: {
            formattedTime: function() {
                return moment.utc(this.time * 1000).format('HH:mm:ss');
            },
            formattedMinTime: function() {
                return moment.utc(this.outline.require_min_time * 60 * 1000).format('HH:mm:ss');
            },
            formattedLessonTime: function() {
                return moment.utc((this.time * 1000) + (this.outline.time * 60 * 1000)).format('HH:mm:ss');
            },
            parsedBlocks: function() {
                if (this.component && this.component.content) {
                    let content = this.component.content;
                    if (typeof content === 'string') content = JSON.parse(content);
                    return content.content;
                } else {
                    return [];
                }
            },
            quizResults: function() {
                let results = {
                    questions: 0,
                    answered: 0,
                    correct: 0,
                    incorrect: 0
                };
                let data = this.component.content;
                for (let i = 0; i < data.blocks.length; i++) {
                    const block = data.blocks[i];
                    if (block.type === 'quizMultiple') {
                        results.questions++;
                        if (this.enrollment.data[block.data.id]) {
                            results.answered++;
                            if (this.enrollment.data[block.data.id].correct) {
                                results.correct++;
                            } else {
                                results.incorrect++;
                            }
                        }
                    }
                }
                results.score = results.correct / results.questions;
                return results;
            }
        },
        methods: {
            saveData(payload) {
                this.$emit('saveData', payload);
            },
            gradeQuiz: function() {
                this.quizGraded = false;
                if (this.quizResults.questions !== this.quizResults.answered) {
                    window.alert('Please answer all questions first.');
                } else {
                    let data = this.component.content;
                    for (let i = 0; i < data.blocks.length; i++) {
                        const block = data.blocks[i];
                        if (block.type === 'quizMultiple') {
                            if (this.enrollment.data[block.data.id] && this.enrollment.data[block.data.id].correct) {
                                // correct
                                block.data.graded = 'correct';
                                block.data.reveal = true;
                            } else {
                                // incorrect
                                block.data.graded = 'incorrect';
                                if (this.outline.quiz_min_score >= (this.quizResults.score * 100)) {
                                    // passed quiz
                                    block.data.reveal = (this.outline.quiz_pass_reveal === 1);
                                } else {
                                    // failed quiz
                                    block.data.reveal = (this.outline.quiz_fail_reveal === 1);
                                }
                            }
                        }
                    }
                    this.quizGraded = true;
                }
            },
            retryQuiz: function() {
                let data = this.component.content;

                for (let i = 0; i < data.blocks.length; i++) {
                    const block = data.blocks[i];
                    if (block.type === 'quizMultiple') {
                        block.data.graded = false;
                        block.data.reveal = false;

                        if (this.outline) {
                        }
                        if (this.outline.quiz_retry_correct && this.enrollment.data[block.data.id].correct) this.enrollment.data[block.data.id] = null;
                        if (this.outline.quiz_retry_incorrect && !this.enrollment.data[block.data.id].correct) this.enrollment.data[block.data.id] = null;
                    }
                }
                this.quizGraded = false;
            },
        },
        mounted() {
            // TODO doing this here has reactive issues
            // this.component.content = JSON.parse(this.component.content);
            // for (let i = 0; i < this.component.content.blocks.length; i++) {
            //     const block = this.component.content.blocks[i];
            //     if (block.type === 'quizMultiple') {
            //         block.data.graded = false;
            //         block.data.reveal = false;
            //     }
            // }

            if (this.outline.completed_at) {
                console.log('Marking quiz complete');
                this.quizGraded = true;
                this.gradeQuiz();
            }
        }
    };
</script>

<style lang="scss" scoped>
    .lesson-content-frame {
        position: absolute;
        top: 105px;
        left: 5rem;
        right: 4rem;
        bottom: 7rem;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 5px 5px 30px 0 rgba(0, 0, 0, 0.3);
        padding: 2rem 2rem 7rem;

        overflow-x: hidden;
        overflow-y: auto;
    }

    .content-controls {
        position: absolute;
        left: 5rem;
        right: 4rem;
        bottom: 1.5rem;
        padding: 3rem 0 1rem;
        font-size: 0.85rem;

        color: white;

        strong {
            color: white;
        }
    }
</style>
